import styled from '@emotion/styled';
import { createElement, FC } from 'react';

import ProjectTypesList from '../../connected/ProjectTypesList';
import { SCREEN_LARGE } from '../../constant/pageWidth';
import { SPACING_HUGE, SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import mq from '../../styleUtility/mediaquery';

type Props = {
  className?: string;
};

const ProjectTypesListPage: FC<Props> = ({ className }) => {
  return (
    <Root className={className}>
      <ProjectTypesList />
    </Root>
  );
};

const Root = styled('section')`
  width: auto;
  max-width: ${SCREEN_LARGE}px;
  margin-top: ${SPACING_HUGE}px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: ${SPACING_UNIT * 12}px;
  ${mq('sp')} {
    padding-left: ${SPACING_REGULAR}px;
    padding-right: ${SPACING_REGULAR}px;
  }
`;

export default ProjectTypesListPage;
